export default __webpack_public_path__ + "static/BankAustria-7c14f6de777ac96768a81810d3dc9da5.png";